import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { ZefErrorHandler } from '@shared/error.handler';

@NgModule({
  providers: [
    {
      provide: ErrorHandler,
      useClass: ZefErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
})
export class ZefSentryModule {}
